import { CrudService } from '../base/CrudService';
export class RequestPurchaseOrderService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestPurchaseOrderService.DEFAULT_SERVICE_PATH,
            basePath: RequestPurchaseOrderService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Generate a purchase order from a request and quotation
     * @param model - PO generation parameters
     * @returns The generated purchase order
     */
    async generatePO(model) {
        const response = await this.http.post(this.buildUrl('generate'), model);
        if (!response.data) {
            throw new Error('Failed to generate purchase order');
        }
        return response.data;
    }
}
RequestPurchaseOrderService.DEFAULT_SERVICE_PATH = 'procurements';
RequestPurchaseOrderService.BASE_PATH = 'api/requestpurchaseorder';
//# sourceMappingURL=RequestPurchaseOrderService.js.map